export const routes = {
  home: () => '/',
  about: () => '/about',
  play: () => '/play',
  media: () => '/media',
  mediaType: (type: string) => `/media/${type}`,
  press: () => '/press',
  contact: () => '/contact',
  community: () => '/community',
  accessibility: () => '/accessibility',
  legal: {
    privacy: () => '/legal/privacy',
    terms: () => '/legal/terms',
    cookies: () => '/legal/cookies',
  },
  blog: {
    index: () => '/blog',
    post: (slug: string) => `/blog/${slug}`,
    category: (category: string) => `/blog/category/${category}`,
    tag: (tag: string) => `/blog/tag/${tag}`,
  },
  database: {
    index: () => '/database',
    items: (id?: string) => (id ? `/database/items/${id}` : '/database/items'),
    skills: (id?: string) => (id ? `/database/skills/${id}` : '/database/skills'),
    classes: (id?: string) => (id ? `/database/classes/${id}` : '/database/classes'),
    enemies: (id?: string) => (id ? `/database/enemies/${id}` : '/database/enemies'),
    statusEffects: () => '/database/status-effects',
    search: () => '/database/search',
  },
  search: () => '/search',
  sitemap: () => '/sitemap.xml',
  robots: () => '/robots.txt',
  rss: () => '/rss.xml',
  status: () => '/api/health',
};

export type RouteBuilder = typeof routes;
